document.addEventListener("DOMContentLoaded", function() {
	$(document).ready(function(){

		const focusVisible = document.focusVisible;
		if($("#wp--skip-link--target").length > 0){
			var elementTop = $("#wp--skip-link--target").offset().top + $("#wp--skip-link--target").height();
		}

		document.querySelectorAll('.quick-access a[href^="#"]').forEach(function (link) {
			link.addEventListener('click', function (e) {
				const targetId = this.getAttribute('href').slice(1);
				const target = document.getElementById(targetId);

				if (target) {
					if (target.id === 'accessibility-settings') {
						const link = target.querySelector('a');
						if (link) {
							link.focus();
							return;
						}
					}
					setTimeout(() => {
						target.setAttribute('tabindex', '-1');
						target.focus();
					}, 100);
				}
			});
		});

		$(".access a").on("click", function(e){
			$("#accessconfig").find('button').click();
			e.preventDefault();
			return false;
		});

		const buttons = document.querySelectorAll('.read_more_button');
		buttons.forEach(button => {
			button.addEventListener('click', () => {
				const expanded = button.getAttribute('aria-expanded') === 'true';
				const answer = document.getElementById(button.getAttribute('aria-controls'));

				button.setAttribute('aria-expanded', String(!expanded));
				answer.hidden = expanded;
			});
		});

		document.addEventListener('wpcf7invalid', function (event) {
			setTimeout(() => {
				const form = event.target;
				const fields = form.querySelectorAll('.wpcf7-form-control-wrap');

				fields.forEach(wrap => {
					const input = wrap.querySelector('[name]');
					if (!input || !input.classList.contains('wpcf7-not-valid')) return;

					const message = wrap.parentElement.querySelector('.wpcf7-not-valid-tip');
					const label = input.getAttribute('data-label') || 'ce champ';
					const type = input.getAttribute('type');

					if (message) {
						const errorId = 'error-' + Math.random().toString(36).substr(2, 9);
						message.id = errorId;
						if (type === 'email') {
							message.textContent = `Le champ ${label} est invalide. Veuillez saisir une adresse mail valide (avec @). Exemple : dupont.jean@orange.fr`;
						} else if (type === 'tel') {
							message.textContent = `Le champ ${label} est invalide. Veuillez saisir un numéro de téléphone valide. Exemple : 01 23 45 67 89`;
						} else {
							message.textContent = `Le champ ${label} est obligatoire.`;
						}
						message.setAttribute('role', 'alert');
						message.removeAttribute('aria-hidden');
						input.setAttribute('aria-describedby', errorId);
					}
				});
			}, 10);
		});
		
		document.addEventListener('wpcf7invalid', function(event) {
			setTimeout(() => {
				const firstInvalid = event.target.querySelector('.wpcf7-not-valid');
				if (firstInvalid) {
					firstInvalid.focus({ preventScroll: false });
				}
			}, 10);
		}, false);
	});
});